const ENRICH_SPRING_ENDPOINT = process.env.ENRICH_SPRING_ENDPOINT;
const MATCH_SPRING_ENDPOINT = process.env.MATCH_SPRING_ENDPOINT;
const BR_SCHEDULER_SPRING_ENDPOINT = process.env.BR_SCHEDULER_SPRING_ENDPOINT;
const CASH_SPRING_ENDPOINT = process.env.CASH_SPRING_ENDPOINT;
const REPROCESS_SPRING_ENDPOINT = process.env.REPROCESS_SPRING_ENDPOINT;
const BASE_AMOUNT_CAL_ENDPOINT = process.env.BASE_AMOUNT_CAL_ENDPOINT;

const NODE_ENDPOINT = process.env.API_URL + ':' + process.env.API_PORT;
// const AI_BOT_URL = process.env.AI_BOT_URL;

module.exports = {
    user: {
        logout: '/api/recon/entitlements/user/logout',
        login: NODE_ENDPOINT + '/api/recon/entitlements/login',
        ssoLogin: NODE_ENDPOINT + '/api/recon/entitlements/azure/sso-login',
        register: '/api/recon/entitlements/register',
        user: '/api/recon/entitlements/user',
        status: '/api/recon/entitlements/user/status',
        users: '/api/recon/entitlements/users',
        profileInfo: '/api/recon/entitlements/user/profileinfo',
        location: '/api/recon/entitlements/user/location',
        root: '/api/recon/entitlements/user',
        registerUser: '/api/recon/entitlements/user/registration',
        roles: '/api/recon/entitlements/user/role',
        roleUpdate: '/api/recon/entitlements/user/role-update',
        applications: '/api/recon/entitlements/user/applicationDashboard',
        dashboards: '/api/recon/entitlements/user/dashboard',
        routes: '/api/recon/entitlements/user/dashboard-routes',
        authorization: '/api/recon/entitlements/user/authorization',
        delete: '/api/recon/entitlements/user/delete',
        userUpdate: '/api/recon/entitlements/user/user-update',
        details: '/api/recon/entitlements/user/details',
        screenPermissions: '/api/recon/entitlements/user/screen-permissions',
        ssAccessToken: '/api/recon/entitlements/user/super-set-access-token',
        supersetLink: '/api/recon/entitlements/user/super-set-link',
    },
    configuration: {
        sourceConfiguration: '/api/recon/source-configuration',
        viewConfiguration: '/api/recon/view-configuration',
        dynamicViewConfiguration: '/api/recon/view-configuration/dynamic',
        viewFieldMap: '/api/recon/view-field-map',
        dataDictionary: '/api/recon/data-dictionary',
        reconConfiguration: '/api/recon/recon-configuration',
        reconConfigurationSettings: '/api/recon/recon-configuration-settings',
        matchingTypes: '/api/recon/default/st-rules',
        filters: '/api/recon/default/st-filters',
        matchingConditions: '/api/recon/default/st-matching-conditions',
        fixedConditions: '/api/recon/default/st-fixed-conditions',
        matchStatus: '/api/recon/default/st-recon-match-status-filter',
        appRoutes: '/api/recon/default/st-app-routes',
    },
    refData: {
        groupSetup: '/api/reference-data/group-setup',
        dataDictionary: '/api/reference-data/data-dictionary',
        groupConfiguration: '/api/reference-data/group-configuration',
        sourceConfiguration: '/api/reference-data/source-configuration',
        apiChatBot: '/api/reference-data/default/chat',
        groupSourceFieldMappings: '/api/reference-data/group/source-fields/mappings',
        groupSourceNameMappings: '/api/reference-data/group/source-names/mappings',
        linkGroupFieldMappings: '/api/reference-data/group/field-linking/mapping',
        blocDataExplorerSchemas: '/api/reference-data/blocdata-explorer/schemas',
        refDataGoldenCopySchemas: '/api/reference-data/refdatagoldencopy-explorer/schemas',
        refDataGoldenCopyExplorerRecords: '/api/reference-data/refdatagoldencopy-explorer/records',
        refDataGoldenCopyExplorerRecordsByClientId: '/api/reference-data/refdatagoldencopy-explorer/recordsbyclientid',
        blocDataExplorerRecords: '/api/reference-data/blocdata-explorer/records',
        blocDataExplorerDeleteRecord: '/api/reference-data/blocdata-explorer/delete',
        blocDataExplorerUpdateRecord: '/api/reference-data/blocdata-explorer/update',
        blocDataExplorerCreateRecord: '/api/reference-data/blocdata-explorer/create',
        blocDataExplorerfilterByCreatedDate: '/api/reference-data/blocdata-explorer/filterDate',
    },
    transactions: {
        brSource: '/api/recon/transactions/br-source',
        brSourceEnRiched: '/api/recon/transactions/br-source-enriched',
        brExceptions: '/api/recon/transactions/br-exceptions',
    },
    sourceConfiguration: {
        fieldMappings: '/api/recon/source-configuration/field-mappings',
        getMappedFieldColumns: '/api/recon/source-configuration/columns',
        settings: '/api/recon/source-configuration/settings',
        jsonConfigs: '/api/recon/source-configuration/json-config',
        sourceComments: '/api/recon/source-configuration/import-source-comments',
        truncateSourceData: '/api/recon/source-configuration/truncate-source-data',
    },
    dataDictionary: {
        root: '/api/recon/data-dictionary',
        defaultDictionaries: '/api/recon/data-dictionary/default-dictionaries',
        pendingDDFiles: '/api/recon/data-dictionary/pending-dd-files',
    },
    tradeExplorer: {
        root: '/api/recon/trade-explorer',
        attachments: '/api/recon/trade-explorer/attachments',
        status: '/api/recon/trade-explorer/status',
    },
    reconConfiguration: {
        root: '/api/recon/recon-configuration',
        fieldMappings: '/api/recon/recon-configuration/mapping-configuration',
        filters: '/api/recon/recon-configuration/mapping-configuration/filters',
        reconSummary: '/api/recon/recon-configuration/recon-summary',
        reconSummaryTypes: '/api/recon/recon-configuration/recon-summary-records',
        linkedSouresAndRecons: '/api/recon/recon-configuration/recon-linked-data',
    },
    rules: {
        root: '/api/recon/rules',
        appRules: '/api/recon/rules/app-rules',
        defaultMatchingTypes: '/api/recon/rules/matching-types',
        dictionaryColumns: '/api/recon/rules/matching-types',
        matchingRules: '/api/recon/rules/mapping/matching-rules',
        matchingRulesInfo: '/api/recon/rules/mapping/matching-rules-info',
        predictRules: '/api/recon/rules/predict-rules',
        llmConfig: '/api/recon/rules/llm-config',
    },
    matchingRulesNames: {
        root: '/api/recon/static/matching-rule/name',
        getRuleNames: '/api/recon/static/matching-rule/matching-rule/names',
        updateMatchingRuleProcessingOrder: '/api/recon/static/matching-rule/names/processing-order',
    },
    adjustmentConfiguration: {
        root: '/api/recon/static/adjustment/configuration',
        workflow: '/api/recon/static/adjustment/configuration/workflow',
        workflowConfiguration: '/api/recon/static/adjustment/configuration/workflow-configuration',
        workflowConfigurationByRecon: '/api/recon/static/adjustment/configuration/workflow-configuration-by-recon',
        reportsWorkflow: '/api/recon/static/adjustment/configuration/report-workflow',
        serverFolders: '/api/recon/static/adjustment/configuration/server-folders',
        swiftTemplate: '/api/recon/static/adjustment/configuration/swift-template',
        pendingWorkflow: '/api/recon/static/adjustment/configuration/pending-workflow',
    },
    reconSourceNameMappings: '/api/recon-source/name/mappings',
    reconSourceFieldAggregationMappings: '/api/recon-source/name/mappings/aggregation',
    reconSourceFieldMappings: '/api/recon/recon-source-field-mappings',
    reconSourceFieldFilters: '/api/recon/recon-source-field-mappings/calculation-filter',
    validateQueryExpression: '/api/recon/recon-source-field-mappings/calculation-expression-validation',
    sqlQueryExpression: '/api/recon/recon-source-field-mappings/sql-expression',
    lookUpExpression: '/api/recon/recon-source-field-mappings/lookup-expression',
    reconFieldMappings: '/api/recon/recon-setup-configuration',
    reconFieldSettings: '/api/recon/recon-setup-settings',
    reconAccess: '/api/recon/shared-component',
    copyFieldsFromSource: '/api/recon/recon-setup-configuration/copy-from-source',
    sourceExplorer: {
        root: '/api/recon/source-explorer',
        auth: '/api/recon/source-explorer/auth',
        delete: '/api/recon/source-explorer/delete',
        dashboard: '/api/recon/source-explorer/dashboard',
        filterByDate: '/api/recon/source-explorer/filter/date',
        import: '/api/recon/import-export/source-explorer',
        migrationAssistant: '/api/recon/import-export/migration-assistant',
        migrationAssistantImport: '/api/recon/import-export/migration-assistant/import',
        uploadValidRecords: '/api/recon/import-export/migration-assistant/upload',
        validateFiles: '/api/recon/import-export/source-explorer/checker',
        export: '/api/recon/import-export/source-explorer',
        template: '/api/recon/import-export/template/source-explorer',
        importDD: '/api/recon/import-export/setup/dd-import',
        view: '/api/recon/source-explorer/view',
        pendingFiles: '/api/recon/source-explorer/pending-files',
    },
    formula: {
        resolve: '/api/recon/formula/resolve',
    },
    reconExplorer: {
        root: '/api/recon/recon-explorer/recon-assets',
        auth: '/api/recon/recon-explorer/auth',
        totalCountData: '/api/recon/recon-explorer/totalCountData',
        filterByDateAndMatching: '/api/recon/recon-explorer/filter/date-and-matching',
        defaultFilterMatching: '/api/recon/recon-explorer/default/date-and-matching',
        matchedData: '/api/recon/recon-explorer/matched-data',
        updateComments: 'api/recon/recon-explorer/updateComments',
        manualMatching: 'api/recon/recon-explorer/manualMatching',
        volumeManualMatching: 'api/recon/recon-explorer/volumeManualMatching',
        matchingAssets: 'api/recon/recon-explorer/matching-assets',
        reconSummaryData: 'api/recon/recon-explorer/recon-summary-data',
        eventMonitoring: 'api/recon/recon-explorer/event-monitoring',
        eventMonitoringRulesLock: 'api/recon/recon-explorer/event-monitoring/import-rules-lock',
        sourceSummaryData: 'api/recon/recon-explorer/source-summary-data',
        deleteRecon: 'api/recon/recon-explorer/delete-recon-details',
        workflowAction: 'api/recon/recon-explorer/workflow-action',
        manualTrigger: 'api/recon/recon-explorer/manual-trigger',
        reconSummaryFlow: '/api/recon/recon-explorer/recon-summary-flow',
        signoff: '/api/recon/recon-explorer/signoff',
        snapshot: '/api/recon/recon-explorer/snapshot',
        signoffdate: '/api/recon/recon-explorer/signoffdate',
        signoffpending: '/api/recon/recon-explorer/signoffpending',
        pendingTAStatus: '/api/recon/recon-explorer/pending-ta-items',
        assignpreparerandchecker: '/api/recon/recon-explorer/assignpreparerandchecker',
        fundDetails: '/api/recon/recon-explorer/fund-details',
        removeFundFromRecon: '/api/recon/recon-explorer/remove-fund-from-recon',
    },
    calculation: {
        root: '/api/recon/calculation',
        filter: '/api/recon/calculation/filter',
    },
    event: {
        root: '/api/recon/event/setup',
        pendingSetup: '/api/recon/event/pending-setup',
        authSetup: '/api/recon/event/auth-setup',
    },
    report: {
        root: '/api/recon/report/setup',
        createConfig: '/api/recon/report/createConfig',
        deleteReport: '/api/recon/report/deleteReport',
        reportFields: '/api/recon/report/reportFields',
        newReportFields: '/api/recon/report/reportfields-mappings',
        reportSettings: '/api/recon/report/reportfields-settings',
        reportWorkflow: '/api/recon/report/reportfields-workflow',
        reportReconMappings: '/api/recon/report/reportReconMappings',
        sqlQueryExpression: '/api/recon/report/sqlQueryExpression',
        reportreconfieldmaps: '/api/recon/report/reportreconfieldmaps',
        reportreconfieldexpressions: '/api/recon/report/reportreconfieldexpressions',
        reportCustomQuery: '/api/recon/report/report-custom-query',
        reportFormatting: '/api/recon/report/reportFormatting',
        validateQueryExpression: '/api/recon/report/calculation-expression-validation',
    },
    filters: '/api/recon/recon-source-filters',
    spring: {
        match: {
            triggerEvent: MATCH_SPRING_ENDPOINT + '/engineapi/recon/jobs',
            triggerReconEvent: BR_SCHEDULER_SPRING_ENDPOINT + '/api/scheduler/recon/jobs',
            adhocEngineSimulate: MATCH_SPRING_ENDPOINT + '/engineapi/simulate',
            rollForward: MATCH_SPRING_ENDPOINT + '/engineapi/roll-forward',
            deleteReconDate: MATCH_SPRING_ENDPOINT + '/engineapi/delete-reconDate',
            executeSummary: MATCH_SPRING_ENDPOINT + '/engineapi/executeSummary',
            updateLabels: MATCH_SPRING_ENDPOINT + '/engineapi/label-manual-action',
            updateComments: MATCH_SPRING_ENDPOINT + '/engineapi/comment-manual-action',
            updateCommentsBulk: MATCH_SPRING_ENDPOINT + '/engineapi/comment-manual-action-bulk',
            updateLabelsBulk: MATCH_SPRING_ENDPOINT + '/engineapi/label-manual-action-bulk',
            validateMatch: MATCH_SPRING_ENDPOINT + '/engineapi/manualMatching',
            executeCopyLabel: MATCH_SPRING_ENDPOINT + '/engineapi/holding_copy_comments',
            executeAPIImportManual: MATCH_SPRING_ENDPOINT + '/engineapi/apiImportManual',
        },
        enrich: {
            newAssets: ENRICH_SPRING_ENDPOINT + '/createAssetRequest',
            newAssetRequest: ENRICH_SPRING_ENDPOINT + '/newAssetRequest',
            newImportAssetRequest: ENRICH_SPRING_ENDPOINT + '/newImportAssetRequest',
            updateAssets: ENRICH_SPRING_ENDPOINT + '/updateAssetRequest',
            deleteAsset: ENRICH_SPRING_ENDPOINT + '/deleteAssetRequest',
            refDataRequest: ENRICH_SPRING_ENDPOINT + '/newRefDataRequest',
            createRefTrade: ENRICH_SPRING_ENDPOINT + '/createRefTradeRequest',
            undelitem: ENRICH_SPRING_ENDPOINT + '/unmapped-items',
        },
        cashItem: {
            updateBatchBalances: CASH_SPRING_ENDPOINT + '/cash-recon-validation/api/v1/updateBatchBalances',
            addItemToBatch: CASH_SPRING_ENDPOINT + '/cash-recon-validation/api/v1/addItemToBatch',
            approveDuplicates: CASH_SPRING_ENDPOINT + '/cash-recon-validation/api/v1/approveDuplicates',
            reprocess: REPROCESS_SPRING_ENDPOINT + '/recon-transformation/api/v1/reprocess',
            baseAmountCalc: BASE_AMOUNT_CAL_ENDPOINT + '/base-amount-processor/api/v1/fx-rate-change',
            baseAmountProcessor: BASE_AMOUNT_CAL_ENDPOINT + '/base-amount-processor/api/v1/security-change',
            updateFxRate: BASE_AMOUNT_CAL_ENDPOINT + '/base-amount-processor/api/v1/update-base-amount',
            securityItem: BASE_AMOUNT_CAL_ENDPOINT + '/base-amount-processor/api/v1/update-security-item',
        },
    },
    infiniteTableProperties: {
        root: '/api/infinite-table-properties',
        tableMetaProperties: '/api/infinite-table-properties/table-meta-properties',
        tableInfiniteExtract: '/api/infinite-table-properties/table-infinite-extract',
        exportAll: 'api/infinite-table-properties/export-all-data',
        virtualColumns: '/api/infinite-table-properties/virtual-column',
        virtualColumnsData: '/api/infinite-table-properties/virtual-column/columns',
        newAssetRequest: '/api/infinite-table-properties/enrich-engine',
        newMatchingRequest: '/api/infinite-table-properties/matching-engine',
        advanceGroupNodes: '/api/infinite-table-properties/advance-group-nodes',
        advanceFundsNodes: '/api/infinite-table-properties/advance-funds-nodes',
        extractRowsAdvancedGroupNodes: '/api/infinite-table-properties/advance-group-nodes/extract',
        moveFiles: '/api/infinite-table-properties/move-files',
        createFolder: '/api/infinite-table-properties/create-folder',
        showFiles: '/api/infinite-table-properties/show-files',
        downloadFiles: '/api/infinite-table-properties/download-files',
        uploadChunks: '/api/infinite-table-properties/upload/chunk',
        lastImportPath: '/api/infinite-table-properties/last-file-import',
    },
    graphql: {
        root: '/api/explorer/audit-logging',
        getAllSchemas: '/api/explorer/audit-logging/schemas',
        audit: '/api/explorer/audit-logging/audit',
        reconGraph: '/api/explorer/audit-logging/recon-graph',
        simulation: '/api/explorer/audit-logging/simulation',
        immutableDB: '/api/explorer/audit-logging/audit/immudb',
    },
    connectors: {
        connection: '/api/data-pipeline/adapter/connector',
        databases: '/api/data-pipeline/adapter/connector/databases',
        schemas: '/api/data-pipeline/adapter/connector/schemas',
        tables: '/api/data-pipeline/adapter/connector/tables',
        columns: '/api/data-pipeline/adapter/connector/columns',
        catalogs: '/api/data-pipeline/adapter/connector/catalogs',
    },
    cashReferenceDataExplorer: '/api/explorer/cash-reference-data',
    cashRecon: {
        ignoreItem: '/api/explorer/cash-item/ignore',
        unIgnoreItem: '/api/explorer/cash-item/unignore',
        removeFileItems: '/api/explorer/cash-item/remove-file-items',
        createGroupItems: '/api/explorer/cash-item/groupitems',
        updateGroupItems: '/api/explorer/cash-item/updategroupitems',
        getGroupItems: '/api/explorer/cash-item/groupitems',
        cashItemRC: '/api/explorer/cash-item/cashItemRC',
        removeGroupItems: '/api/explorer/cash-item/groupitems',
        getBatchamount: '/api/explorer/cash-item/get-batch',
        editBalanceItems: '/api/explorer/cash-item/edit-balance',
        deleteBalanceItems: '/api/explorer/cash-item/delete-balance',
        excludeMatching: '/api/explorer/cash-item/excludeMatching',
        splitItem: '/api/explorer/cash-item/split',
        createException: '/api/explorer/cash-item/create-exception',
        getException: '/api/explorer/cash-item/get-exception',
        getExceptionLabel: '/api/explorer/cash-item/get-exception-label',
        getAllException: '/api/explorer/cash-item/all-exception',
        deleteException: '/api/explorer/cash-item/delete-exception',
        addException: '/api/explorer/cash-item/add-exception',
        removeException: '/api/explorer/cash-item/remove-exception',
        auth: '/api/explorer/cash-item/auth',
        authDDtype: '/api/explorer/cash-item/auth-dd-type',
        auditRecords: '/api/explorer/cash-item/audit-records',
        accountsList: '/api/explorer/cash-item/accounts',
        reprocess: '/api/explorer/cash-item/reprocess',
        settings: '/api/explorer/cash-item/settings',
        getholdingrecondata: '/api/explorer/cash-item/getholdingrecondata',
        getgroupid: '/api/explorer/cash-item/getgroupid',
        getTaReconOrders: '/api/explorer/cash-item/get-ta-recon-orders',
        updateTaOrders: '/api/explorer/cash-item/update-ta-recon',
        singOffTaRecon: '/api/explorer/cash-item/signoff-ta-recon',
        getTransactionType: '/api/explorer/cash-item/get-transaction-type',
        getReconDate: '/api/explorer/cash-item/get-recon-date',
    },
    // aiDataTrigger: AI_BOT_URL + '/fetchcommentsforunmatched',
};
